export default function inventoryStateManager() {
  let instance = null;
  let player = null;
  let content = getPrototypeContent();
  function getPrototypeContent() {
    return {
      brandAwareness: 0,
      experience: 0,
      npcLocations: {
        cowboy: { location: 0 },
        jackson: { location: 0 },
        kaison: { location: 0 },
        linda: { location: 0 },
        liv: { location: 0 },
        margie: { location: 0 },
        oldMan: { location: 0 },
      },
      possibleAchievements: [
        "firstClass",
        "firstInspection",
        "allClasses",
        "firstHarvest",
        "firstSale",
        "firstSplit",
        "firstRequeen",
        "firstAddHive",
        "firstPollination",
        "20Jars",
        "100Jars",
        "200Jars",
        "500Jars",
        "1000Jars",
        "10Hives",
        "20Hives",
        "50Hives",
        "10HoneyFrames",
        "50HoneyFrames",
        "100HoneyFrames",
        "500HoneyFrames",
        "10Inspections",
        "25Inspections",
        "50Inspections",
        "100Inspections",
        "250Inspections",
        "500Inspections",
        "1000Inspections",
      ],
      achievements: [],
      stings: { count: 0, stings: [], lastMutated: null },
      stingTolerance: 5,
      inspections: 0,
      beeClasses: {
        signedUp: null,
        completed: [],
        classes: {
          honeyClasses: [
            {
              id: "honey101",
              name: "Honey 101",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hi Beeks and Prospective Beeks, welcome to Honey 101`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `To begin collecting honey, you must have honey boxes (supers) on your hive. You can add them in the hive menu!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `Once you have some honey boxes on your hives you can inspect your hives to see your bees' progress with the sweet stuff.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `At any point, whether your box is full of honey or not, you can harvest, or add more honey boxes. You can do this in the hive menu!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `Once you have harvested some honey frames you have to process them. The first step is the honey extractor, you can find this in your honey house!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `The extractor acts as a centrifuge, removing all of the sweet viscous honey from your frames.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `When your frames have been spun, you can bottle the honey by using the bottling tank! This is the last step before the market!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `Once you have some honey jars you can start to sell your honey. The most lucrative method is person to person, or via your honey stand. Other methods of sale include the markets and bars/restaurants (everyone loves mead around here!)`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You'll tend to get around $10 per jar from your honey stand, and anywhere from $3 to $6 per jar elsewhere.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Your honey stand and the honey on the shelves of the markets will increase in sales as you increase your brand's awareness level by interacting with the townfolk. Just remember to be nice, because you can negatively affect the awareness level as well!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Honey 101. Next Recommended Class: Biology 101`,
                  ],
                },
              ],
            },
            {
              id: "honeyProduction",
              name: "Honey Production",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Welcome to our class on Honey Production. For many, Honey is the #1 goal of keeping bees! Today we'll talk about how you can maximize your honey load.`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `In order to produce honey, you need bees, lots of bees. The more foragers a colony can send out, the more nectar it can bring in!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `It is to our advantage to try to maximize the colony population WHEN the nectar is flowing. So, May, June, July and September should be high population months.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `During these honey flow months it is IMPERATIVE that you are consistently inspecting, adding boxes whenever necessary and paying attention to the brood nest.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `The bees love to swarm while the nectar is flowing so it is on you to make sure either they don't, or that you use it to your advantage (SPLITS!)`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `Don't let your brood nest become honeybound (filled with honey). This is prevented by making sure your bees have honey boxes on during the flow!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `If you pay attention to those points of interest, I think you'll have some SWEET SUCCESS!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes HONEY PRODUCTION. NEXT Recommended Class: Honey Harvesting`,
                  ],
                },
              ],
            },
            {
              id: "honeyHarvesting",
              name: "Honey Harvesting",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Welcome to HONEY HARVESTING. Today We will discuss all aspects of honey processing. Let's Get Started`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `When you have full honey frames, you can harvest! Do this in the Hive Menu. Once your frames are harvested you have to spin them in the extractor to remove the honey.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You can find your extractor in your honey house! You can upgrade your extractor either online or at the Bee Club Market.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once you have spun your frames you can bottle the honey using the bottling tank. This is the last step of Honey Harvesting.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Be sure to either leave enough honey or feed your bees before winter. Bees cannot survive without enough carbohydrate energy! It's a good rule of thumb to have at least a full honey box on all hives when going into winter.`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `Don't feel bad about taking honey and feeding sugar syrup! During winter, bees need energy, and sugar is a clean energy source. Honey is energy but often laden with plant solids that can be difficult for the bees to deal with during the cold winter months.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Honey Harvesting. Next Recommended Class: Honey Sales`,
                  ],
                },
              ],
            },
            {
              id: "honeySales",
              name: "Honey Sales",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Welcome To Honey Sales. Today We'll Talk About All Aspects Of Selling Honey.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `When you have jars of honey, you can sell them in any of these methods: Person To Person, Honey Stand, Farmer's Market, Furdland Market, McCarty's Restaurant`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You will always get more for your jars if you are the one selling it to the end consumer! Honey Stand and Person To Person often gets $10 per jar, whereas stores like Furdland will return $3.`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `But, as you grow as a Beek, your honey pulls will grow, and it becomes difficult to sell all of your honey, which leads to the big box stores like Furdland being an eventual necessity.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Your honey will often sell faster, and you will find more available shelf space in the stores, as your Brand Awareness levels go up. You can increase this metric by interacting with townfolk and selling honey.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `So, remember, be loquacious, courteous, and active in the community for the best chance to sell all of your honey!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Honey Sales. Next Recommended Class: Biology 101`,
                  ],
                },
              ],
            },
          ],
          biologyClasses: [
            {
              id: "biology101",
              name: "Biology 101",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Beeks, Welcome To Biology 101. Let's Get Started`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Honey bees start off as an egg laid by the queen. After 3 days, the egg hatches into a larva.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once the larva is big enough, worker bees cover the cell with wax and the baby bee becomes a pupa! It is during this stage that the bee features (wings, eyes legs) become to take form.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once the pupa has developed, it chews its way out of the cell and begins life as an adult bee!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `The amount of time it takes for an egg to turn into adult is different depending on the type of bee! Queens develop in 16 days, workers take 21, and drones take 24!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Adult worker bees spend their lives doing different jobs for the colony. First, they have nurse duty! They clean brood cells, feed larva, and tend to the queen. After nursing duty they become guard bees, and then they graduate to foraging duty!!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `Worker bees lifespan depends on the time of year it was born! Summer bees live hard, fast lives, usually dying after about 6 weeks! Bees born in the fall, or "winter bees" can live as long as 6 months!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Biology 101. Next Recommended Class: Mites`,
                  ],
                },
              ],
            },
            {
              id: "mites",
              name: "Mites",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Bearded Bee People. Welcome to Mites. Let's Get Started!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `There are a few different mites that parisitize European Honey Bees, but today we will talk about the most important, impactful, and damaging, the VARROA MITE.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Varroa mites and European Honey Bees did not evolve together. Varroa are natural parasites of the Asian Honey Bee, and came into contact with the European Honey Bee within the last 50 or so years.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Whereas Asian Honey Bees have defense mechanisms designed to keep varroa at bay, European Honey Bees do not, and often require beekeeper intervention in order to survive.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Varroa mites start their lives off in honey bee brood cells, multiplying as the colony's numbers rise, vectoring disease and weakening the population.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Beekeepers must keep an eye on the varroa numbers, and we do this by performing "mite washes". You can do this in the hive menu!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `If the mite wash shows mites (and it usually will!), there may be actions necessary, this is dependent on the time of year and the number of varroa mites`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You can treat by using Acid Pads (90% effective, medium damage to the bees), Acid Vapor (20% effective, no damage to bees) or Synthetic Pads (99% effective, high damage to bees)`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Mites. Next Class Recommendation: Queen Production`,
                  ],
                },
              ],
            },
            {
              id: "queenProduction",
              name: "QueenProduction",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Bearded Bee People. Welcome To Queen Production. Let's Get Started.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Honey Bee Colonies create queens by making queen cells. These are larger cells that take a fertilized egg and put it on the fast track to queendom!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Queen cells take 16 days to develop into a virgin queen!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Within the first two weeks of the new queen's life she will go out on one or a few mating flights, mating with up to 20 drones at a time!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `When she returns to her hive after mating, she begins laying eggs and gets the royal treatment from the workers!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Honey Bee Colonies will create queens for a few different reasons: Swarming (propagation), Supersedure, or Emergency.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You can find queen cells in your hive by noting the size! In this game, they will always appear at the bottom of the frame!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `When you find cells in your hive you must use context clues to figure out why the cell is there, is it a swarm cell? supersedure? or emergency? The actions you take next depend on the answer!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Queen Production. Next Class Recommendation: Swarms`,
                  ],
                },
              ],
            },
            {
              id: "swarms",
              name: "Swarms",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Workers and Drones. Welcome To Swarms. Let's Get Started.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Bees swarm to propagate! In this action, the old queen leaves the hive with between 20% and 80% of the workforce! They leave behind one to MANY queen cells and brood. If successful, a hive can swarm from one to 6 or 8 times in a year!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `As beekeepers, we don't really want this to happen, when they swarm they often leave our yards, or take residence in an inconvenient spot. It would better suit us to catch it before it happens and use it to our advantage!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `To be aware of oncoming swarms, you must inspect your hives regularly, once you start seeing really cramped boxes, full of bees, brood and honey, you can start to expect a swarm response. This will show itself via queen cells, usually two or more, spread throughout the brood nest.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once you find these cells you can use them to your advantage by making splits! You can do this in the hive menu!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Bees tend to only want to swarm during the spring or early summer, but will swarm at any time in the year if the brood nest is honeybound or the hive cavity is too cramped.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Swarms! Next class recommendation: Splits`,
                  ],
                },
              ],
            },
            {
              id: "pheromones",
              name: "Pheromones",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Bearded Bee People, Today's Class Is On Pheromones. Let's Get Started`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Honey Bees communicate with each other in a few different methods. Sometimes to convey the location of food they will do what is called a waggle dance, moving their butts in a pattern that indicates the food distance and location to her sisters.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Other ways that bees communicate is via pheromones, or specific scents that convey ideas or needs. Examples of honey bee pheromones are the ATTACK pheromone and queen pheromones.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Queen pheromones are what tell the colony that their queen is either doing well or nearing the end of her fertile life. Depending on the strength of the pheromones she gives off the bees may decide to supersede her! Off with her head!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `The queen pheromone is also why it is sometimes difficult to give a colony a new queen. They recognize the pheromone of their queen and will defend her if they think she's still in the hive! This is why you must wait 24 hours before introducing a queen to a new split!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `The attack pheromone is one you'll end up becoming familiar with over time, as, it is what the bees dispense when they are being disturbed! This pheromone smells a LOT like bananas, or banana oil, and if you ever get stung in the nose you'll find out first hand!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `You can mitigate the attack pheromone by smoking the hive just before you crack the lid during an inspection, but, that is not a foolproof method so if you're keeping bees for long enough you're gonna get a nose stinger at some point!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes pheromones. Next Recommended Class: Bee Season`,
                  ],
                },
              ],
            },
            {
              id: "beeSeason",
              name: "Bee Season",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Bearded Bee People! Today We're Talking About The Bee Season. Let's Get Started.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Honey bees come out of winter with an intense desire to build! They want to build more comb and to forage for enough food to allow the queen to lay TONS of eggs so that they can be strong enough to swarm later on in the year.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `As beekeepers, we must help them with this effort! Feed during the Spring if they don't have any stores, allow them to build! You will use their strength in numbers later in the year!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `As the Spring wanes and Summer nears, the bees desire usually (depending on the colony) switches to swarm mode. They want to send out one or many strong swarms to spread their genetics! This is not something we want to allow to happen.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `It is at this point (some time during the spring) that we want to take at least one split. This will help remove the swarm instinct from the colony, and will help you grow as a beekeeper!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You can make a walk away split, or split with a queen cell, or split and add a mated queen, either way, just make sure you remove some bees, brood and food from the hive to convince the bees that they have swarmed!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once the swarm instinct has been dealt with the name of the game switches to honey! Add boxes as necessary and keep an eye on the brood nest so that it doesn't get cramped or honeybound.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `In August/September the Summer will start to wane, the days will start to get shorter, and the bees will use this as a cue to start rearing winter bees! Winter bees are biologically distinct workers that are set up to survive long cold periods inside the hive! `,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `It is imperative that these winter bees are reared in a relatively mite and disease free environment. Sick winter bees don't survive! Make sure your mite loads are low at the end of summer to assist in this effort.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `As the bees are rearing their winter kin, they desire to fill their hive up with food! It is at this point in the year when we stop being concerned about the brood nest being honeybound. We want food in the hive, lots of food, everywhere!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `So, if it's September, October or November and your colonies aren't heavy and full of honey or syrup, you must feed! Feed Fast, Feed A Lot, Feed!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `And once the bees are happy, heavy and healthy, you've done your work as a Beek! You can cross your fingers that your bees make it through the winter!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Bee Season. Next Recommended Class: Hive Space Management`,
                  ],
                },
              ],
            },
          ],
          hiveManagementClasses: [
            {
              id: "beekeeping101",
              name: "Beekeeping 101",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Beeks and Prospective Beeks, Welcome to Beekeeping 101, in this class I hope to familiarize you with all of the terms and actions that a beekeeper must be familiar with. Let's start.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Honey bees live in hives, usually with thousands of workers, one queen and a few drones (male bees). A hive's goal each year is to collect enough nectar and pollen to support the queen's egg laying  and to store enough honey to get through the winter`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `As beekeepers (in real life and in this game), we can take any of a few actions to help and use the bees' instinct to our advantage. These include but are not limited to: `,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Adding/Removing Brood boxes, Adding/Removing Honey boxes, Feeding (sugar syrup), Harvesting Honey, Splitting (turning one hive into two or more) and treating for mites`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Add boxes when they're cramped, remove boxes if there is too much space. Feed ANY time there is no food in the hive, or if winter is coming. Test for mites REGULARLY, and treat if the levels get too high.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You can do all of these things in the hive menu! Access the hive menu by interacting with your hive and pressing the SPACE bar.`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `That's all for Beekeeping 101, remember, you can retake these classes at any time, and you can access the TUTORIAL INTERFACE in your bee yard by pressing I`,
                  ],
                },
                {
                  action: "dialog",
                  content: [`Recommended Next Class: Honey 101`],
                },
              ],
            },
            {
              id: "hiveSpace",
              name: "Hive Space Management",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Ladies And Gents. Welcome To Hive Space Management. Let's Get Started.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `One of our primary actions as beekeepers is adding/removing boxes. We do this to harvest honey and keep the overall hive cavity size appropriate for the workforce!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `You can add and remove boxes in the hive menu. Try to inspect your bees often and, during the spring and summer, add more space when they near max capacity.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once the summer wanes, we stop caring so much about adding honey boxes and become more attuned to managing space for winter survival. In this effort it is a good idea to give them enough space to store enough food for winter, but not too much that it becomes difficult to keep warm.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Hive Space Management. Next Recommended Class: Splits`,
                  ],
                },
              ],
            },
            {
              id: "splits",
              name: "Splits",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Ladies And Gents. Welcome To Splits. Let's Get Started.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `To split your hive, access the split menu in the hive menu! There you can select the amount of brood and honey frames to transfer to the split.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once you have made your split(s), you can place them in your bee yard using the SPACE bar.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `If you selected a queen cell for your split, this cell will develop into an adult queen, if you didn't select a cell, the newly queenless bees will begin creating queen cells using the EMERGENCY response.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Either way, you should expect a laying queen within about 3 weeks, BUT, this doesn't always happen. From damaged queen cells to birds eating queens on mating flights, there are lots of reasons why your queen might go missing. Expect your splits within this time period so that you can make corrective action if necessary.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Splits. Next Recommended Class: Winter Prep`,
                  ],
                },
              ],
            },
            {
              id: "feeding",
              name: "Feeding",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Bearded Bee People. Welcome To Feeding. Let's Get Started.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `As beeks, we often need to feed our hives, and failure to do so will (in a lot of cases), result in the colony's death`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `To feed your colony you need white granulated sugar. This sugar is then mixed into a simple syrup and fed to the bees.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `In early spring just after the bees come out of winter, before winter when you're trying to get your colony's weights up, or any other point in the season when your bees are lacking for food, FEED THEM!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `Some people like to say that taking honey from bees and feeding sugar syrup is bad, or unnatural, and I'm here to tell you that it is not! The role of honey for a honey bee colony is carbohydrate energy! Sugar is an excellent source of carbs, and can often result in less bathroom trips and house maintenance by the bees.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Feeding. Next Recommended Class: Winter Prep`,
                  ],
                },
              ],
            },
            {
              id: "winterPrep",
              name: "Winter Prep",
              content: [
                {
                  action: "dialog",
                  content: [
                    `Hello Ladies and Drones. Welcome to Winter Prep. Let's Get Started`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `As the bee season comes to a close, the toughest part of the year for the bees is on the horizon... The WINTER!`,
                  ],
                },
                {
                  action: "move",
                  direction: "exclaim",
                  content: null,
                },
                {
                  action: "dialog",
                  content: [
                    `In order to survive the winter, our bees need lots of food, available all over the hive. They need at LEAST 1 box if not 2, full of honey or syrup, to last through the winter. Don't let your bees go into winter under weight!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Winter survival depends on the bees' health as well. A mite ridden, diseased colony just cannot last through an already arduous time with these added stresses. It is IMPERATIVE that you treat your bees before WINTER BEES are being reared.`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `Once your bees are happy, heavy and healthy, your work as a beek is over for the season! Stop inspecting them, stop worrying about them. If you've done your job correctly you'll see them in the Spring!`,
                  ],
                },
                {
                  action: "dialog",
                  content: [
                    `This concludes Winter Prep. Next Recommended Class: Honey Production`,
                  ],
                },
              ],
            },
          ],
        },
      },
      furdland: { lastSold: null },
      farmersMarket: { lastSold: null },
      mccartys: { lastSold: null },
      sparkys: { lastSold: null },
      bigBens: { lastSold: null },
      beeClubMarket: {
        lastPerused: null,
        items: { bees: [], boxes: [], extractors: [] },
      },
      gameIntro: {
        firstContent: [
          "At a time in your life when you were searching...",
          "For a purpose, a quest, a reason for living...",
          "You received a note from your Grandpa.",
          "Your eyes light up in nostalgic delight...",
        ],
        secondContent: [
          "You remember him as a gruff but lovable old man",
          "But that was a long time ago, by this time he must be very old.",
          "You think to yourself,",
          `'I sure would like to see him, I wonder what he wants'`,
        ],
        letterContent: `<h2>Hey Kiddo,</h2>
        <p>Your mother mentioned that you were blue, and that life wasn't everything you hoped it would be.</p>
        <p>I'm not sure I have the perfect answer for you, but I do have an offer.</p>
        <p>Start over, here in Kozmania with me. This place is a fantastic spot to start a new life. The locals are friendly and the way of life is simple.</p>
        <p>I sure could use the help on the farm. Beekeeping isn't what it used to be. The damned mites killed almost everything and I'm too old to learn a new way.</p>
        <p>So, my offer is this, come and take over my bee farm. I will teach you everything I know about bees and we can rebuild the apiary better than before.</p><p>- Grandpa Bo</p>
        `,
      },
      houseIntro: { viewed: false, should: true },
      grandpa: {},
      colin: {
        met: false,
        relationship: 0,
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      katie: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      linda: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      roger: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      sparky: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      kennedy: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      kaison: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      liv: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      ronald: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      bigBen: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      marvin: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      bill: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      kevin: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      jackson: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
      margie: {
        met: false,
        relationship: 0,
        randomQuestions: [],
        answers: {
          firstQuestion: null,
          secondQuestion: { shouldShow: false, reply: null, index: null },
        },
      },
    };
  }
  function createInstance() {
    return {
      setPlayer: (value) => {
        console.log("setting player state: ", value);
        player = value;
      },
      getPlayer: () => {
        console.log("getPlayer: ", player);
        return player;
      },
      setContent: (value) => {
        console.log("inside setContent should be random: content is: ", value);
        if (!value) {
          content = getPrototypeContent();
        } else {
          content = value;
        }
      },
      getContent: () => {
        return content;
      },
    };
  }
  return {
    getInstance: () => {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
}
